import * as React from 'react';
import type { DataSourceEnumControlProps } from '@web-config-app/entity-form';
import { useEntityFormDataSource } from '@web-config-app/entity-form';
import { SelectInputControl } from '../../select-input-control/select-input-control.component';

export const EntityDataSourceEnumControl: React.FC<
  DataSourceEnumControlProps
> = ({ dataSource, dataSourceConsumer, ...props }) => {
  const value = useEntityFormDataSource({ dataSource, dataSourceConsumer });

  if (value && typeof value === 'object' && 'enumOptions' in value) {
    const { enumOptions } = value;
    return <SelectInputControl {...props} enumOptions={enumOptions} />;
  }

  // eslint-disable-next-line no-console
  console.error(
    'EntityDataSourceEnumControl: No enumOptions found in data source.',
  );
  return null;
};
